import React from 'react';
import styled, { css } from 'styled-components';
import * as animations from '../../styles/animations';

const AnimatedParticle = styled.div<{ $x: number; $delay: number; $duration: number }>`
  position: absolute;
  left: ${props => props.$x}%;
  bottom: 0;
  width: 4px;
  height: 4px;
  background: rgba(255, 68, 68, 0.6);
  border-radius: 50%;
  will-change: transform, opacity;
  ${props => css`
    animation: ${animations.particleFloat} ${props.$duration}s linear infinite;
    animation-delay: ${props.$delay}s;
  `}
`;

// Componente de partículas animadas
export const AnimatedParticles: React.FC = () => {
  const particles = React.useMemo(() => Array.from({ length: 20 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    delay: Math.random() * 5,
    duration: 3 + Math.random() * 4,
  })), []);

  return (
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none', overflow: 'hidden' }}>
      {particles.map((particle) => (
        <AnimatedParticle
          key={particle.id}
          $x={particle.x}
          $delay={particle.delay}
          $duration={particle.duration}
        />
      ))}
    </div>
  );
};
